// import {
//   Box,
//   Flex,
//   HStack,
//   ResponsiveValue,
//   useBreakpointValue,
//   Image,
//   Button,
// } from '@chakra-ui/react';
// import { FaPowerOff } from 'react-icons/fa';
// import { MdSupportAgent } from 'react-icons/md';
// import { CustomText } from '../atoms/CustomText';
// import { CustomButton } from '../atoms/CustomButton';
// import { appInsights } from '../../appInsights';
// import { useAuth } from '../../stateManagement/auth/useAuth';
// import { trackEvent } from '../../Analytics/ga';
// import { HamburgerMenu } from './HamburgerMenu';

// interface MainHeaderProps {
//   logoUrl?: string; // Type for logo URL
//   logoSize?: ResponsiveValue<string>;
//   gameTitle: string; // Type for game title
//   horizontalPadding?: ResponsiveValue<string>; // Optional horizontal padding type
//   darkMode?: boolean;
//   marginStart?: ResponsiveValue<string>;
//   showHeaderLogo?: boolean;
//   mainHeaderBgColor: string;
//   mainHeaderTextColor: string;
//   changeTheme?: any;
//   loginButtonText: string;
//   onClickLandingPageButton?: () => void;
//   // targetUrl?: string;
//   onClickMainHeading?: () => void;
//   platforms: string[]; // Array of platform names
//   secondaryAccentColor: string;
//   headerTextColors: string;
//   onButtonClick?: () => void;
//   color?: string;
//   buttonBgColor?: string;
//   contactUsButtonText?: string;
//   landingPageHref?: () => string | undefined;
//   contactUsHref?: () => string | undefined;
// }
// export const MainHeader: React.FC<MainHeaderProps> = ({
//   logoUrl,
//   gameTitle,
//   logoSize,
//   marginStart,
//   showHeaderLogo,
//   mainHeaderBgColor = '#fefefe',
//   mainHeaderTextColor,
//   loginButtonText,
//   onClickLandingPageButton,
//   // targetUrl,
//   onClickMainHeading,
//   secondaryAccentColor,
//   headerTextColors,
//   onButtonClick,
//   contactUsButtonText,
//   landingPageHref,
//   contactUsHref,
// }) => {
//   const { isAuthenticated, handleLogin, handleLogout } = useAuth();
//   const onClickImage = () => {
//     appInsights.trackEvent({
//       name: 'header',
//       properties: { buttonName: 'headerLogoButton', userName: 'anonymous' },
//     });
//     trackEvent('header_logo_clicked', {
//       page: 'header',
//       action: 'navigate_home',
//     });
//     if (onClickLandingPageButton) {
//       onClickLandingPageButton();
//     }
//   };

//   const showContactText = useBreakpointValue({ base: false, md: true }); // hide text on small screens
//   const showLoginText = useBreakpointValue({ base: false, md: true });

//   const buttonBg = useBreakpointValue({
//     base: 'transparent',
//     md: isAuthenticated ? secondaryAccentColor : mainHeaderBgColor,
//   });

//   const iconColor = useBreakpointValue({
//     base: secondaryAccentColor,
//     md: headerTextColors,
//   });
//   const powerIconSize = useBreakpointValue({ base: '28px', md: '22px', lg: '20px' });
//   const contactUsIconSize = useBreakpointValue({ base: '32px', md: '26px', lg: '24px' });

//   return (
//     <Box px={{ base: 6, md: 16, lg: 24 }} py={2} backgroundColor={mainHeaderBgColor}>
//       <Flex alignItems="center" justifyContent="space-between">
//         {/* Logo and Title */}
//         <Flex
//           alignItems="center"
//           flexDirection={{ base: 'column', md: 'row' }}
//           textAlign={{ base: 'center', md: 'left' }}
//           zIndex="2"
//         >
//           {showHeaderLogo && (
//             <a
//               href={landingPageHref ? landingPageHref() : undefined}
//               style={{ display: 'contents', textDecoration: 'none' }}
//             >
//               <Image
//                 src={logoUrl}
//                 alt="Logo"
//                 width={logoSize ?? '140px'}
//                 color={mainHeaderTextColor}
//                 cursor="pointer"
//                 onClick={(e: {
//                   button: number;
//                   metaKey: any;
//                   ctrlKey: any;
//                   shiftKey: any;
//                   altKey: any;
//                   preventDefault: () => void;
//                 }) => {
//                   const isLeftClick = e.button === 0;
//                   const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
//                   // SPA routing on normal click
//                   if (isLeftClick && !isModifiedClick) {
//                     e.preventDefault();
//                     onClickImage();
//                   }
//                 }}
//               />
//             </a>
//           )}
//           <CustomText
//             fontSize={{ base: 'md', md: 'lg' }}
//             fontWeight="bold"
//             marginStart={marginStart}
//             mt={{ base: '2', md: '0' }}
//             color={mainHeaderTextColor}
//             onClick={onClickMainHeading}
//           >
//             {gameTitle}
//           </CustomText>
//         </Flex>

//         <HStack spacing={{ base: 2, md: 4, lg: 6 }} align="center" zIndex="2">
//           {/* Contact Us Button */}
//           <a href={contactUsHref ? contactUsHref() : undefined}>
//             <Button
//               onClick={e => {
//                 const isLeftClick = e.button === 0;
//                 const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
//                 // SPA routing on normal click
//                 if (isLeftClick && !isModifiedClick) {
//                   e.preventDefault();
//                   onButtonClick?.();
//                 }
//               }}
//               size="md"
//               fontSize="lg"
//               backgroundColor={buttonBg}
//               color={headerTextColors}
//               borderRadius="0"
//               display="flex"
//               alignItems="center"
//               justifyContent="center"
//               px={{ base: 3, md: 5 }}
//               _hover={{ boxShadow: 'md', transform: 'scale(1.05)' }}
//               fontWeight="bold"
//             >
//               <HStack spacing={2}>
//                 {showContactText ? (
//                   <HStack spacing={2}>
//                     <MdSupportAgent size={contactUsIconSize} color={iconColor} />
//                     <Box as="span" fontWeight="600">
//                       {contactUsButtonText}
//                     </Box>
//                   </HStack>
//                 ) : (
//                   <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
//                     <Box transform="translateX(-2px)">
//                       <MdSupportAgent size={contactUsIconSize} color={iconColor} />
//                     </Box>
//                     <Box
//                       as="span"
//                       fontSize="xs"
//                       mt={0.5}
//                       fontWeight="600"
//                       color={iconColor}
//                       transform="translateX(-2px)"
//                     >
//                       {contactUsButtonText}
//                     </Box>
//                   </Box>
//                 )}
//               </HStack>
//             </Button>
//           </a>

//           {/* Auth Button */}
//           <CustomButton
//             onClick={() => {
//               if (isAuthenticated) {
//                 trackEvent('user_logout_clicked', { page: 'header' });
//                 handleLogout();
//               } else {
//                 handleLogin();
//               }
//             }}
//             backgroundColor={buttonBg}
//             color={headerTextColors}
//             borderRadius="0"
//             display="flex"
//             alignItems="center"
//             justifyContent="center"
//             px={{ base: 3, md: 5 }}
//             _hover={{ boxShadow: 'lg', transform: 'scale(1.05)' }}
//             mt={{ base: 1, md: 0 }}
//           >
//             <HStack spacing={2}>
//               {showLoginText ? (
//                 <HStack spacing={2}>
//                   <FaPowerOff size={powerIconSize} color={iconColor} />
//                   <Box fontWeight="600" as="span">
//                     {isAuthenticated ? 'LOGOUT' : loginButtonText}
//                   </Box>
//                 </HStack>
//               ) : (
//                 <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
//                   <Box transform="translateX(-2px)">
//                     <FaPowerOff size={powerIconSize} color={iconColor} />
//                   </Box>
//                   <Box
//                     as="span"
//                     fontSize="xs"
//                     mt={0.5}
//                     fontWeight="600"
//                     color={iconColor}
//                     transform="translateX(-2px)"
//                   >
//                     {isAuthenticated ? 'LOGOUT' : loginButtonText}
//                   </Box>
//                 </Box>
//               )}
//             </HStack>
//           </CustomButton>
//           <HamburgerMenu />
//         </HStack>
//       </Flex>
//     </Box>
//   );
// };

import {
  Box,
  Flex,
  HStack,
  ResponsiveValue,
  useBreakpointValue,
  Image,
  Button,
} from '@chakra-ui/react';
import { FaPowerOff } from 'react-icons/fa';
import { MdSupportAgent } from 'react-icons/md';
import { CustomText } from '../atoms/CustomText';
import { CustomButton } from '../atoms/CustomButton';
import { appInsights } from '../../appInsights';
import { useAuth } from '../../stateManagement/auth/useAuth';
// import { trackEvent } from '../../Analytics/ga';
import { HamburgerMenu } from './HamburgerMenu';
import { useSettings } from '../../stateManagement/SettingsContext';

interface MainHeaderProps {
  logoUrl?: string;
  logoSize?: ResponsiveValue<string>;
  gameTitle: string;
  horizontalPadding?: ResponsiveValue<string>;
  darkMode?: boolean;
  marginStart?: ResponsiveValue<string>;
  showHeaderLogo?: boolean;
  mainHeaderBgColor: string;
  mainHeaderTextColor: string;
  changeTheme?: any;
  loginButtonText: string;
  onClickLandingPageButton?: () => void;
  onClickMainHeading?: () => void;
  platforms: string[];
  secondaryAccentColor: string;
  headerTextColors: string;
  onButtonClick?: () => void;
  color?: string;
  buttonBgColor?: string;
  contactUsButtonText?: string;
  landingPageHref?: () => string | undefined;
  contactUsHref?: () => string | undefined;
  isPreviewMode?: boolean;
}

export const MainHeader: React.FC<MainHeaderProps> = ({
  logoUrl,
  gameTitle,
  logoSize,
  marginStart,
  showHeaderLogo,
  mainHeaderBgColor = '#fefefe',
  mainHeaderTextColor,
  loginButtonText,
  onClickLandingPageButton,
  onClickMainHeading,
  secondaryAccentColor,
  headerTextColors,
  onButtonClick,
  contactUsButtonText,
  landingPageHref,
  contactUsHref,
  isPreviewMode,
}) => {
  const { isAuthenticated, handleLogin, handleLogout } = useAuth();
  const rawHamburgerLinks = useSettings().hamburgerMenuLinks;
  const hamburgerConfig = rawHamburgerLinks;

  const hasValidHamburgerItems =
    Array.isArray(hamburgerConfig?.navConfig) &&
    hamburgerConfig.navConfig.some(
      (item: { path?: string }) => typeof item?.path === 'string' && item.path.trim() !== '',
    );

  const buttonBg = useBreakpointValue({
    base: 'transparent',
    md: isAuthenticated ? secondaryAccentColor : mainHeaderBgColor,
  });

  const iconColor = useBreakpointValue({
    base: secondaryAccentColor,
    md: headerTextColors,
  });

  const powerIconSize = useBreakpointValue({ base: '28px', md: '22px', lg: '20px' });
  const contactUsIconSize = useBreakpointValue({ base: '32px', md: '26px', lg: '24px' });

  const onClickImage = () => {
    appInsights.trackEvent({
      name: 'header',
      properties: { buttonName: 'headerLogoButton', userName: 'anonymous' },
    });

    // trackEvent('header_logo_clicked', {
    //   page: 'header',
    //   action: 'navigate_home',
    // });

    if (onClickLandingPageButton) {
      onClickLandingPageButton();
    }
  };

  return (
    <Box px={{ base: 6, md: 16, lg: 24 }} py={2} backgroundColor={mainHeaderBgColor}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex
          alignItems="center"
          flexDirection={{ base: 'column', md: 'row' }}
          textAlign={{ base: 'center', md: 'left' }}
          zIndex="2"
        >
          {showHeaderLogo && (
            <a
              href={landingPageHref ? landingPageHref() : undefined}
              style={{ display: 'contents', textDecoration: 'none' }}
            >
              <Image
                src={logoUrl}
                alt="Logo"
                width={logoSize ?? '140px'}
                color={mainHeaderTextColor}
                cursor="pointer"
                onClick={(e: any) => {
                  const isLeftClick = e.button === 0;
                  const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
                  if (isLeftClick && !isModifiedClick) {
                    e.preventDefault();
                    onClickImage();
                  }
                }}
              />
            </a>
          )}
          <CustomText
            fontSize={{ base: 'md', md: 'lg' }}
            fontWeight="bold"
            marginStart={marginStart}
            mt={{ base: '2', md: '0' }}
            color={mainHeaderTextColor}
            onClick={onClickMainHeading}
          >
            {gameTitle}
          </CustomText>
        </Flex>

        <HStack spacing={{ base: 2, md: 4, lg: 6 }} align="center" zIndex="2">
          {/* Contact Us Button - Hidden on mobile/tablet, shown on desktop (lg) */}
          <Box display={{ base: 'none', lg: 'block' }}>
            <a href={contactUsHref ? contactUsHref() : undefined}>
              <Button
                onClick={e => {
                  const isLeftClick = e.button === 0;
                  const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
                  if (isLeftClick && !isModifiedClick) {
                    e.preventDefault();
                    onButtonClick?.();
                  }
                }}
                size="md"
                fontSize="lg"
                backgroundColor={buttonBg}
                color={headerTextColors}
                borderRadius="0"
                display="flex"
                alignItems="center"
                justifyContent="center"
                px={{ base: 3, md: 5 }}
                _hover={{ boxShadow: 'md', transform: 'scale(1.05)' }}
                fontWeight="bold"
              >
                <HStack spacing={2}>
                  <MdSupportAgent size={contactUsIconSize} color={iconColor} />
                  <Box as="span" fontWeight="600">
                    {contactUsButtonText}
                  </Box>
                </HStack>
              </Button>
            </a>
          </Box>

          {/* Auth Button - Hidden on mobile/tablet, shown on desktop (lg) */}
          <Box display={{ base: 'none', lg: 'block' }}>
            <CustomButton
              onClick={() => {
                if (isAuthenticated) {
                  // trackEvent('user_logout_clicked', { page: 'header' });
                  handleLogout();
                } else {
                  handleLogin();
                }
              }}
              backgroundColor={buttonBg}
              color={headerTextColors}
              borderRadius="0"
              display="flex"
              alignItems="center"
              justifyContent="center"
              px={{ base: 3, md: 5 }}
              _hover={{ boxShadow: 'lg', transform: 'scale(1.05)' }}
              mt={{ base: 1, md: 0 }}
            >
              <HStack spacing={2}>
                <FaPowerOff size={powerIconSize} color={iconColor} />
                <Box fontWeight="600" as="span">
                  {isAuthenticated ? 'LOGOUT' : loginButtonText}
                </Box>
              </HStack>
            </CustomButton>
          </Box>

          {!isPreviewMode && hasValidHamburgerItems ? (
            <HamburgerMenu
              loginButtonText={loginButtonText}
              contactUsButtonText={contactUsButtonText}
              onButtonClick={onButtonClick}
            />
          ) : null}
        </HStack>
      </Flex>
    </Box>
  );
};
